<template>
  <transition name="fade">
    <div
      v-if="isActive"
      :id="`overlay-${overlayId}`"
      class="overlay-main"
      role="dialog"
      :aria-labelledby="`${overlayId}-title`"
      :aria-describedby="`${overlayId}-description`"
    >
      <button
        v-if="showCloseOutside"
        :style="buttonStyles"
        class="close"
        @click="closeIt"
      >
        <div />
        <div />
      </button>
      <div
        class="slot-container"
        :style="contentStyles"
      >
        <button
          v-if="showCloseContained"
          :style="buttonStyles"
          class="close contained"
          @click="closeIt"
        >
          <div />
          <div />
        </button>
        <slot />
      </div>

      <div
        class="background-cover"
        :style="overlayStyles"
      />
    </div>
  </transition>
</template>

<script>

  import { mapActions, mapState } from 'vuex'

  export default {
    name: 'Overlay',
    props: {
      overlayId: {
        type: String,
        required: true
      },
      showCloseOutside: {
        type: Boolean,
        default: false
      },
      showCloseContained: {
        type: Boolean,
        default: false
      },
      contentWidth: {
        type: Number,
        default: 600
      },
      contentHeight: {
        type: Number,
        default: 600
      },
      closeButtonSize: {
        type: Number,
        default: 15
      },
      overlayBackgroundColor: {
        type: String,
        default: '#242021'
      },
      overlayBackgroundOpacity: {
        type: String,
        default: '1'
      },
    },
    computed: {
      ...mapState('overlay', ['activeOverlay']),
      isActive() {
        return this.activeOverlay === this.overlayId
      },
      contentStyles() {
        return {
          maxWidth: `${this.contentWidth}px`,
          height: `${this.contentHeight}px`,
        }
      },
      buttonStyles() {
        return {
          width: `${this.closeButtonSize}px`,
          height: `${this.closeButtonSize}px`
        }
      },
      overlayStyles() {
        return {
          background: (this.overlayBackgroundColor),
          opacity: (this.overlayBackgroundOpacity)
        }
      }
    },
    methods: {
      ...mapActions('overlay', ['registerOverlay', 'deactivateOverlay']),
      closeIt() {
        this.deactivateOverlay()
      }
    },
    mounted() {
      this.registerOverlay(this.overlayId)
    }
  }
</script>
